<div class="flex h-full flex-col p-0">
  <ul class="nv-tab group">
    @for (tab of tabs; track tab) {
      <li (click)="selectTab(tab)" [class.active]="tab.active" class="cursor-pointer">
        <a>{{ tab.tabTitle | translate }}</a>
      </li>
    }
  </ul>
  <div class="nv-taboverlay h-full"><ng-content></ng-content></div>
</div>
